import { Dialog } from 'radix-ui';
import { useState } from 'react';
import { useHotkey, useRegisteredShortcuts } from '@/lib/hotkeys';
import { Keys } from '@/components/ui/keys';

/** `?` lists every shortcut active on the current screen (collected from useHotkey calls). */
export function ShortcutsDialog() {
  const [open, setOpen] = useState(false);
  const shortcuts = useRegisteredShortcuts();
  useHotkey('shift+?', () => setOpen((o) => !o), {
    description: 'Keyboard shortcuts',
    group: 'General',
  });

  const groups = new Map<string, typeof shortcuts>();
  for (const s of shortcuts) groups.set(s.group, [...(groups.get(s.group) ?? []), s]);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-overlay" />
        <Dialog.Content
          aria-describedby={undefined}
          className="fixed top-1/2 left-1/2 z-50 grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl border bg-popover outline-none p-5 text-popover-foreground shadow-2xl"
        >
          <Dialog.Title className="text-base font-semibold">Keyboard shortcuts</Dialog.Title>
          <div className="grid gap-4 sm:grid-cols-2">
            {[...groups].map(([group, items]) => (
              <section key={group} className="grid content-start gap-1.5">
                <h3 className="text-2xs font-semibold tracking-wide text-muted-foreground uppercase">
                  {group}
                </h3>
                {items.map((s) => (
                  <div
                    key={s.keys + s.description}
                    className="flex items-center justify-between gap-3 text-ui"
                  >
                    <span>{s.description}</span>
                    <Keys combo={s.keys} />
                  </div>
                ))}
              </section>
            ))}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
